import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { trackCTAClick } from "@/lib/analytics";

export const CustomSolution = () => (
    <section
        data-testid="custom-solution-section"
        className="bg-white pb-24 pt-4"
    >
        <div className="mx-auto max-w-5xl px-6 lg:px-8">
            <Reveal>
                <div className="fp-card-shadow flex flex-col items-start gap-6 rounded-3xl border border-gray-100 bg-[#F8FAFC] p-10 sm:flex-row sm:items-center sm:justify-between">
                    <div className="max-w-xl">
                        <h2 className="text-2xl font-bold tracking-tight text-[#0B1F44]">
                            Need something more specific?
                        </h2>
                        <p className="mt-3 text-base leading-relaxed text-[#4B5563]">
                            FlowPilot can also design focused AI and automation
                            solutions for business processes where an
                            off-the-shelf workflow is not enough.
                        </p>
                    </div>
                    <a
                        href="#growth-review"
                        data-testid="custom-solution-cta"
                        onClick={() => trackCTAClick("custom_solution")}
                        className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full border border-[#0B1F44] bg-white px-6 py-3 text-sm font-semibold text-[#0B1F44] transition-colors hover:bg-gray-50"
                    >
                        Discuss a Custom Solution
                        <ArrowRight className="h-4 w-4" />
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
